import { useToast } from "vue-toastification";

const handleApiError = (error: any) => {
  console.warn(error);
  useToast().error(error.response.data.message);
};

export default handleApiError;
